import axios from 'axios';
const client = axios.create({
    baseURL: process.env.VUE_APP_CLOUD_API_URL,
    timeout: 15000,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true,
});
client.interceptors.response.use(undefined, (e) => {
    if (e.response && e.response.status === 401) {
        window.location.href = process.env.VUE_APP_CLOUD_LOGIN_URL;
        return;
    }
    throw e;
});
export default client;
